export enum FundType {
  MUTUAL_FUND = 'MF',
  EXCHANGE_TRADED_FUND = 'ETF'
}

export const FundTypeMap = Object.entries(FundType).reduce((previousValue, currentValue) => {
  previousValue.set(currentValue[1], FundType[currentValue[0]]);
  return previousValue;
}, new Map<string, FundType>());
